import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M29.6 23.511 18.669 4.527a3.095 3.095 0 0 0-5.338 0L2.4 23.511a2.94 2.94 0 0 0 0 2.965A3.04 3.04 0 0 0 5.069 28H26.93a3.04 3.04 0 0 0 2.666-1.524 2.94 2.94 0 0 0 .003-2.965m-1.734 1.964a1.06 1.06 0 0 1-.935.525H5.07a1.06 1.06 0 0 1-.935-.525.95.95 0 0 1 0-.965l10.93-18.984a1.093 1.093 0 0 1 1.876 0L27.87 24.51a.95.95 0 0 1-.005.965M15 18v-5a1 1 0 1 1 2 0v5a1 1 0 0 1-2 0m2.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" }, null, -1)
  ])))
}
export default { render: render }